export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_title_displayImportMsg') || '错误信息',
    field: 'displayImportMsg',
    headerAlign: 'center',
    align: 'left',
    width: 320,
    fixed: 'left',
    slots: { default: 'displayImportMsg' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_user_account') || '用户账号',
    field: 'userNo',
    align: 'left',
    minWidth: 140,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_chinese_name') || '中文姓名',
    field: 'userName',
    align: 'left',
    minWidth: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_english_name') || '英文姓名',
    field: 'userNameEn',
    align: 'left',
    minWidth: 140,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_english_name_abbreviation') || '英文名称缩写',
    field: 'userShortNameEn',
    align: 'left',
    minWidth: 150,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_phone_number') || '手机号码',
    field: 'mobileNumber',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_mailing_address') || '邮件地址',
    field: 'emailAddress',
    align: 'left',
    minWidth: 220,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_fixed_telephone') || '固定电话',
    field: 'fixedTelephone',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_organization') || '所属机构',
    field: 'orgName',
    align: 'left',
    minWidth: 180,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_department') || '所属部门',
    field: 'depName',
    align: 'left',
    minWidth: 180,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_position') || '职位',
    field: 'userPost',
    align: 'left',
    minWidth: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_business') || '业务角色',
    field: 'userJobTypeName',
    align: 'center',
    minWidth: 140,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_cg_cr_permission_range') || '对应客户权限范围',
    field: 'userCustRangeName',
    align: 'center',
    minWidth: 160,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_permission_role') || '权限角色',
    field: 'roleNames',
    align: 'left',
    minWidth: 220,
    showHeaderOverflow: true,
  },
]
